export default __webpack_public_path__ + "static/icon-30-5-c8c20ee9305d7357f835b80df648851d.png";